<template>
  <section>
    <div class="container text-center">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10">
          <Observer name="fade-up">
            <h2 class="title -upper" v-html="item.title" data-aos="fade-in"></h2>
            <div v-html="item.text" class="wysiwyg" data-aos="fade-in"></div>
          </Observer>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
export default {
  props: ['item', 'items', 'pagePosition', 'siblings-components'],
  name: 'title_text_center',
  mixins: [ReadyHook]
}
</script>

<style lang="scss" scoped>
  @import "~theme/css/core";

  .-icons .title {
    display: inline;
    font-size: em(24);
    font-weight: normal;
    color: var(--zenith-white) !important;
    background: var(--zenith-theme-primary) !important;
    box-shadow: -2px 0px 0px 6px var(--zenith-theme-primary);
  }

  section {
    /*margin: 12rem 0 10rem;*/
    margin: 10rem 0;

    @include bp(max md) {
      margin-bottom: 6rem;
    }
  }

  .title {
    margin-bottom: 3rem;
    color: var(--zenith-theme-primary);
  }

  .wysiwyg {
    /deep/ ul, /deep/ ol {
      padding: 0;
      margin-bottom: 2rem;
      font-size: em(18);
      line-height: em(25, 18);
      letter-spacing: em(0.2, 18);
      list-style: none;

      li:before {
        content: '-';
        margin-right: 1.4rem;
      }

      @include bp(max md) {
        font-size: em(16);
        font-weight: normal;
        line-height: em(22, 16);
        letter-spacing: em(.2, 16);
      }
    }

    /deep/ a {
      text-decoration: underline;
      color: var(--zenith-component-title-text-center-text);
    }

    /deep/ p {
      color: var(--zenith-component-title-text-center-text);
      margin-bottom: 2rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>
